<template>
	<div class="paged-list-filter">
		<o-section title="Filtrer par">
			<div class="form row row--grid">
				<div
					v-if="setup.self.isClient()"
					class="col-sm-6">
					<shared-select-user-company
						v-model="setup.filter.clientCompanyId"
						:agency-company-id="setup.filter.agencyCompanyId"/>
				</div>
				<div
					v-if="setup.self.isClient()"
					class="col-sm-6">
					<shared-select-company
						v-model="setup.filter.agencyCompanyId"
						type="agency"/>
				</div>
				<div
					v-if="setup.self.isAgency()"
					class="col-sm-6">
					<shared-select-user-company v-model="setup.filter.agencyCompanyId"/>
				</div>
				<div
					v-if="setup.self.isAgency()"
					class="col-sm-6">
					<shared-select-company
						v-model="setup.filter.clientCompanyId"
						type="client"
						:agency-company-id="setup.filter.agencyCompanyId"/>
				</div>
				<div class="col-sm-6">
					<o-select
						v-model="setup.filter.currentStep"
						label="Statut"
						:options="setup.optionCurrentStep"
						track-key="value"
						value-key="value"
						display-key="label"/>
				</div>
				<div class="col-sm-6">
					<shared-tag-select
						v-model="setup.filter.tagIds"
						multiple
						clearable/>
				</div>
			</div>
		</o-section>

		<o-section align="stretch">
			<o-button
				color="danger"
				outline
				@click="setup.cancelFilter()">
				Annuler
			</o-button>
			<o-button
				outline
				@click="setup.resetFilter()">
				Réinitialiser
			</o-button>
			<o-button
				color="info"
				@click="setup.applyFilterAsync()">
				Appliquer
			</o-button>
		</o-section>
	</div>
</template>

<script setup lang="ts">
import TimeTicketYearPagedListFilterSetupService from '@/setup/time-ticket/TimeTicketYearPagedListFilterSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
// const props = defineProps(TimeTicketYearPagedListFilterSetupService.props);
const setup = new TimeTicketYearPagedListFilterSetupService(undefined, _aside);
</script>
